<main class="dash-content">
  <div class="grid">
    <div class="col-12">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.solicitudes-por-tipo' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-bar #chartBarTipo [config]="barTipoConfig" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.global-solicitudes-pqrsd' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-donut #chartDonutTotal [config]="chartDonutConfig" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.efectividad-global-pqrsd' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-radial-gauge #chartRadialGaugeEfectividad [config]="radialGaugeEfectividadConfig" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-12">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.historico-solicitud-pqrsd' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-line #chartLineHistorico [config]="lineHistoricoConfig" />
        </div>
      </div>
    </div>
  </div>
</main>
